/**
 * Returns true when any identifier field on the task matches the given id.
 *
 * Server-side records only carry `taskId` / `id` / `headerTaskId`. Client-side
 * tasks may additionally carry `temporaryTaskId` for unsaved entries. Checking
 * all four fields lets the same helper run on either side without surprises.
 */
export function taskMatchesIdentifier(task, taskId) {
    if (!task || !taskId) return false
    const target = String(taskId)
    return [task.headerTaskId, task.taskId, task.temporaryTaskId, task.id].some(
        (candidate) => candidate != null && String(candidate) === target
    )
}
